// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"157":"54062398","1556":"0b8c28b6"}[chunkId] + ".chunk.css";
};